// Salesforce オブジェクト名の定数定義

/**
 * Salesforceカスタムオブジェクト名
 *
 * 命名規則:
 * - Salesforce上: dtp_PRSheet_ 接頭辞あり (例: dtp_PRSheet_Sheet__c)
 * - TypeScript型: 接頭辞なし (例: PRSheet)
 */
export const SOBJECT_NAMES = {
  /** PRシート (TypeScript型: PRSheet) */
  PRSHEET: 'dtp_PRSheet_Sheet__c',

  /** PRシートPDF (TypeScript型: PRSheetPDF) */
  PRSHEET_PDF: 'dtp_PRSheet_PDF__c',

  /** PRスキル (TypeScript型: PRSkill) */
  PRSKILL: 'dtp_PRSheet_Skill__c',

  /** PRスキルグループ (TypeScript型: PRSkillGroup) */
  PRSKILL_GROUP: 'dtp_PRSheet_SkillGroup__c',

  /** キャリア (TypeScript型: Career) */
  CAREER: 'Career__c',

  /** これまでの主な取り組み (TypeScript型: PRExperience) */
  EXPERIENCE: 'dtp_PRSheet_Experience__c',

  /** 制作ポートフォリオ (TypeScript型: PRPortfolioItem) */
  PORTFOLIO_ITEM: 'dtp_PRSheet_PortfolioItem__c',

  /** 注力エピソード (TypeScript型: PRHighlightEpisode) */
  HIGHLIGHT_EPISODE: 'dtp_PRSheet_HighlightEpisode__c',

  /** 受賞・認定・資格 (TypeScript型: PRAward) */
  AWARD: 'dtp_PRSheet_Award__c',

  /** リファレンス (TypeScript型: PRReference) */
  REFERENCE: 'dtp_PRSheet_Reference__c',

  /** 学歴 (TypeScript型: PREducation) */
  EDUCATION: 'dtp_PRSheet_Education__c',

  /** 外部リンク (TypeScript型: PRLink) */
  LINK: 'dtp_PRSheet_Link__c',

  /** AIプロンプト (TypeScript型: PRAIPrompt) */
  AI_PROMPT: 'dtp_PRSheet_AIPrompt__c',

  /** AI生成履歴 (TypeScript型: PRAIGeneration) */
  AI_GENERATION: 'dtp_PRSheet_AIGeneration__c',
} as const

/**
 * Salesforce標準オブジェクト名
 */
export const STANDARD_SOBJECT_NAMES = {
  /** コンテンツバージョン (画像アップロード用) */
  CONTENT_VERSION: 'ContentVersion',

  /** コンテンツドキュメント (画像管理用) */
  CONTENT_DOCUMENT: 'ContentDocument',
} as const
